var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x94\x84 Icon 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.645 16.645L12 11.3017L17.355 16.645L19 15L13.0607 9.06066C12.4749 8.47487 11.5251 8.47487 10.9393 9.06066L5 15L6.645 16.645Z",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownExpanded);
export default __webpack_public_path__ + "static/media/dropdownExpanded.b852e6eae24da8289dcb33f7b712c204.svg";
export { ForwardRef as ReactComponent };